import { IonContent, IonDatetime, IonItem, IonLabel, IonModal, IonNote } from '@ionic/react'
import { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import useInput from '../../hooks/useInput'
import { COMPLETE_INPUT } from '../../redux/actions'
import { formatDate } from '../../utils/utils'

interface Props {
  label: string
  flow?: string
  inputName: string
  note?: string
  storeForm: string
  minLimitDate?: string
  maxLimitDate?: string
  defaultDate?: string
  disabled?: boolean
}

const DateForm = ({
  label,
  flow,
  inputName,
  note,
  storeForm,
  minLimitDate,
  maxLimitDate,
  defaultDate,
  disabled
}: Props) => {
  const modal = useRef<HTMLIonModalElement>(null)
  const { input, reduxInput, error, itemRef, handleError, handleInput, clearError, validity } = useInput(
    inputName,
    storeForm
  )
  const [recentlyMounted, setRecentlyMounted] = useState(true)
  const todayDate = new Date().toISOString()
  const displayDate = defaultDate ?? todayDate
  const dispatch = useDispatch()

  useEffect(() => {
    if (validity) dispatch({ type: COMPLETE_INPUT, payload: { name: inputName, value: input, storeForm } })
    else if (!recentlyMounted) dispatch({ type: COMPLETE_INPUT, payload: { name: inputName, value: '', storeForm } })
    setRecentlyMounted(false)
  }, [validity])

  const parseDate = (event: any) => {
    event.detail.value = event.detail.value.slice(0, 19)
    return event
  }

  useEffect(() => {
    if (defaultDate && recentlyMounted)
      dispatch({
        type: COMPLETE_INPUT,
        payload: { name: inputName, value: defaultDate.slice(0, 19), storeForm }
      })
  }, [])

  return (
    <>
      <IonItem id={`date-${inputName}`} disabled={disabled} shape="round" ref={itemRef}>
        <IonLabel id={`${flow}-${inputName}`}>
          {label}
          <span className="dateSelected">
            {input ? formatDate(input) : reduxInput ? formatDate(reduxInput) : formatDate(displayDate)}
          </span>
        </IonLabel>
        <IonModal id={`date-popover-${inputName}`} className="date-modal" ref={modal} trigger={`${flow}-${inputName}`}>
          <IonContent>
            <IonDatetime
              id={`datetime-${inputName}`}
              datatype=""
              name={inputName}
              value={input || reduxInput || displayDate}
              max={maxLimitDate}
              showDefaultButtons={true}
              cancelText="Cancelar"
              doneText="Aceptar"
              presentation="date"
              min={minLimitDate}
              onIonChange={(e) => handleInput(parseDate(e))}
              onIonFocus={clearError}
              onIonBlur={handleError}
            />
          </IonContent>
        </IonModal>
      </IonItem>
      {!error && note ? (
        <IonNote className="input-info">{note}</IonNote>
      ) : (
        !disabled && <span className="input-error">{error}</span>
      )}
    </>
  )
}

export default DateForm
